<template>
    <template v-if="!dismissed">
        <BaseCard class="flex flex-col gap-2.5">
            <div class="flex items-center justify-between gap-2">
                <div class="flex items-center gap-3">
                    <CalendarAttendeeAvatar :name="attendee.name" />
                    <span class="body-small font-medium">{{ attendee.name }}</span>
                </div>
                <BaseButton theme="ghost" icon-only :aria-label="t('connections.editCard.removeAttendee')" data-test-id="remove-attendee-btn" @click="dismissed = true">
                    <i class="bi bi-trash" aria-hidden="true"></i>
                </BaseButton>
            </div>
            <BaseInput v-model="jobTitle" :aria-label="t('connections.editCard.jobTitle')" :placeholder="t('connections.editCard.jobTitle')" />
        </BaseCard>
    </template>
    <template v-else>
        <div class="flex flex-col items-center justify-between gap-2 h-full">
            <div class="grow flex items-center justify-center gap-2 rounded-xl text-ink-muted border border-border-strong bg-surface-sunken w-full px-2.5 py-4">
                <i class="bi bi-trash text-lg/none" aria-hidden="true"></i>{{ t("connections.editCard.removed", { name: attendee.name }) }}
            </div>
            <BaseButton theme="neutral" size="sm" class="w-full" @click="dismissed = false">{{ t("connections.editCard.undo") }}</BaseButton>
        </div>
    </template>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import CalendarAttendeeAvatar from "~vue/components/CalendarAttendeeAvatar.vue";
import BaseInput from "~vue/components/form/BaseInput.vue";
import type { ConnectionCalendarAttendee } from "~vue/types/connection";
import { useI18n } from "vue-i18n";

interface Props {
    attendee: ConnectionCalendarAttendee;
}

defineProps<Props>();

const { t } = useI18n();

const jobTitle = defineModel("title", { type: String, default: "" });
const dismissed = defineModel("dismissed", { type: Boolean, default: false });
</script>
